import {ProjectTypeEnum} from 'features/studio/projects/constants/project-type';

export enum ProjectCategoryFilterEnum {
  INTERIORS = 'interiors',
  PROJECT_ROOM = 'project-room',
  COLLABORATIONS = 'collaborations',
}

const INTERIORS_TYPES = new Set<string>([
  ProjectTypeEnum.ARCHI_RESIDENCE,
  ProjectTypeEnum.ARCHI_HOTEL_RESTAURANT,
  ProjectTypeEnum.ARCHI_RETAIL,
  ProjectTypeEnum.SCENOGRAPHY,
  ProjectTypeEnum.INSTITUTION,
]);

const PROJECT_ROOM_TYPES = new Set<string>([
  ProjectTypeEnum.PROJECT_ROOM,
  ProjectTypeEnum.TINY_ROOM,
]);

const COLLABORATIONS_TYPES = new Set<string>([
  ProjectTypeEnum.DESIGN_COLLABORATIONS,
]);

export const getProjectCategory = (
  projectType?: string
): ProjectCategoryFilterEnum | null => {
  if (!projectType) return null;
  if (INTERIORS_TYPES.has(projectType))
    return ProjectCategoryFilterEnum.INTERIORS;
  if (PROJECT_ROOM_TYPES.has(projectType))
    return ProjectCategoryFilterEnum.PROJECT_ROOM;
  if (COLLABORATIONS_TYPES.has(projectType))
    return ProjectCategoryFilterEnum.COLLABORATIONS;
  return null;
};
